// eslint-disable-next-line no-shadow
export enum AppPlatform {
  Paps = "PAPS",
  Client = "CLIENT"
}
